export enum ValidationContext {
  BoardMeeting,
  FileExchange
}
